import React from "react";
import { FaShieldAlt, FaUsers } from "react-icons/fa";
import { TiArrowSyncOutline } from "react-icons/ti";

import "../styles/WhyChooseUs.css";

export const WhyChooseUs = () => {
  return (
    <div className="why-container">
      <h2 className="why-title">3 Reasons To Choose Us</h2>
      <div className="why-grid">
        <div className="why-card">
          <div className="icon-wrapper">
            <FaShieldAlt className="why-icon" />
          </div>

          <h3>Secure betting</h3>
          <p>
            Built with advanced encryption to ensure the safety of your stake.
          </p>
        </div>

        <div className="why-card">
          <div className="icon-wrapper">
            <TiArrowSyncOutline className="why-icon" />
          </div>
          <h3>Earn Commission on Every Stake</h3>
          <p>Cash back on every game you play. Easy withdrawal.</p>
        </div>

        <div className="why-card">
          <div className="icon-wrapper">
            <FaUsers className="why-icon" />
          </div>
          <h3>Exciting Offers for New Players</h3>
          <p>
            Play All 5/90 Games, anywhere, anytime and any day at the comfort
            of your home
          </p>
        </div>
      </div>
    </div>
  );
};
